import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations.js'
import actions from './action'
import getters from './getters'

//这里把所有需要配置的变量配置在这里
const state = {
    navIndex: '',
    projectConfig: {},
    hashMenus:{}
}
Vue.use(Vuex)

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    //plugins: [vuexLocal.plugin]  //这个插件是为了防止页面刷新的时候，vuex里面的变量没有了，目前不需要，后期需要再打开
})
